import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {usePrevious} from 'react-use';
import {
  selectRoomState,
  HMSRoomState,
  selectIsConnectedToRoom,
  useHMSActions,
  useHMSStore,
} from '@100mslive/react-sdk';
import {Box, Flex} from '@100mslive/react-ui';
import './100-ms-style-override.css';
// import { Header } from "./Header";
// import { Footer } from "./Footer";

// import { RoleChangeRequestModal } from "./RoleChangeRequestModal";

import {useIsHeadless} from './AppData/useUISettings';
import FullPageProgress from './UI-Components/FullPageProgress';
import {ConferenceMainView} from './layouts/mainView';
import {Header} from './Header';
import {Footer} from './Footer';
// import {Footer} from './Footer';

const Conferences = ({meetingUrl}: any) => {
  // const navigate = useNavigate();
  const {roomId, role} = useParams();
  const isHeadless = useIsHeadless();
  const roomState = useHMSStore(selectRoomState);
  const prevState = usePrevious(roomState);
  const isConnectedToRoom = useHMSStore(selectIsConnectedToRoom);
  const hmsActions = useHMSActions();

  useEffect(() => {
    if (false) {
      // if (!roomId) {
      //   navigate(`/`);
      //   return;
      // }
      // if (
      //   !prevState &&
      //   !(roomState === HMSRoomState.Connecting || isConnectedToRoom)
      // ) {
      //   if (role) navigate(`/preview/${roomId || ''}/${role}`);
      //   else navigate(`/preview/${roomId || ''}`);
      // }
    }
  }, [isConnectedToRoom, prevState, roomState, role, roomId]);

  useEffect(() => {
    return () => {
      // This is needed to handle mac touchpad swipe gesture
      if (isConnectedToRoom && false) {
        hmsActions.leave();
      }
    };
  }, []);
  // }, [hmsActions, isConnectedToRoom]);

  if (!isConnectedToRoom) {
    return <FullPageProgress />;
  }

  return (
    <Flex css={{size: '100%'}} direction="column">
      {(!isHeadless || true) && (
        <Box css={{h: '$18', '@md': {h: '$17'}}} data-testid="header">
          <Header />
        </Box>
      )}
      <Box
        css={{
          w: '100%',
          flex: '1 1 0',
          minHeight: 0,
          '@md': {
            marginBottom: 140,
            overflow: 'scroll',
          },
        }}
        data-testid="conferencing">
        <ConferenceMainView />
      </Box>
      {!isHeadless && (
        <Box
          css={{
            flexShrink: 0,
            minHeight: '$24',
            '@md': {
              marginBottom: 120,
              position: 'fixed',
              bottom: '0',
              width: '100%',
            },
          }}
          data-testid="footer">
          <Footer meetingUrl={meetingUrl} />
          {/* `Footer ` */}
        </Box>
      )}
      {/* <RoleChangeRequestModal /> */}
    </Flex>
  );
};

export default Conferences;
